import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757217566402-keyfutureskillslogo%20500x500.jpg" 
                alt="KeyFutureSkills Logo" 
                className="w-10 h-10 rounded-lg"
              />
              <div>
                <span className="text-xl font-bold">LeaderPath</span>
                <p className="text-sm text-gray-400">part of KeyFutureSkills</p>
              </div>
            </div>
            <p className="text-gray-400 max-w-md">
              Empowering new leaders with the tools, assessments, and knowledge they need to succeed in their leadership journey.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#leadership" className="hover:text-white transition-colors">Leadership Topics</a></li>
              <li><a href="#assessments" className="hover:text-white transition-colors">Assessments</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.keyfutureskills.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors flex items-center space-x-2"
              >
                <SafeIcon icon={FiExternalLink} className="text-xl" />
                <span>KeyFutureSkills</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 LeaderPath, part of KeyFutureSkills. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;